
import currencyConverter from "../common/currency-converter.vue";

export default {
  components: { currencyConverter },
  props: {
    menuItem: {
      type: Object,
      required: true
    },
    fontSizeProp: {
      type: String,
      default: "foaps__sub-title-5"
    }
  }
};
